import { EditTradingOfferOperationStatusModalContextType } from '../types/EditTradingOfferOperationModalContextType';

export const editTradingOfferOperationStatusModalInitValue: EditTradingOfferOperationStatusModalContextType =
  {
    data: {
      tradingOfferOperation: null,
      selectedStatusOption: null,
      statusOptions: [],
      isLoading: false,
    },
    actions: {
      handleCloseModal: () => {},
      handleChangeStatusOption: () => {},
      handleUpdateTradingOfferOperationStatus: async () => {},
    },
  };
